(function () {
    'use strict';

    function OrderBagServiceItemController($uibModal, $scope, $state, PriceInfoCustom, PriceInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ServiceOptionItem, ServiceOptionItemCustom, PriceInfoDtailCustom, OrderBagServiceItem, ServiceItemCustom, ServiceTimeSessionCustom, SettingInfoCustom, ServiceTimeSession, dateUtil, ScheduleInfoCustom, TimingInfo, OrderBagCustom) {
        ;
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.formState = 'orderbagitem';
        $ctrl.options = null;
        $ctrl.getPriceInfoDtail = getPriceInfoDtail;
        $ctrl.priceInfoDtails = null;
        $ctrl.addOrderBagDtails = addOrderBagDtails;
        $ctrl.computeTotalPrice = computeTotalPrice;
        $ctrl.isSaving = false;
        $ctrl.saveDtail = saveDtail;
        //$ctrl.findFormState = findFormState;
        $ctrl.prev = prev;
        $ctrl.initParticipant = initParticipant;
        $ctrl.FinalApprove = FinalApprove;
        $ctrl.serviceItem_changed = serviceItem_changed;
        $ctrl.openPersonInfoModal = openPersonInfoModal;
        $ctrl.serviceItems = null;
        $ctrl.removeParticipantPerson = removeParticipantPerson;
        $ctrl.qtyChanged = qtyChanged;
        $ctrl.availableDates_changed = availableDates_changed;
        $ctrl.availableTimes_changed = availableTimes_changed;
        $ctrl.selectedServiceTimeSession = {};
        $ctrl.servant_changed = servant_changed;
        $ctrl.getAvailableDynamicDates = getAvailableDynamicDates;
        $ctrl.getAvailableDynamicTimes = getAvailableDynamicTimes;
        $ctrl.selectedDynamicDate = null;
        $ctrl.selectedDynamicTime = null;
        $ctrl.availableDynamicDates_changed = availableDynamicDates_changed;
        $ctrl.availableDynamicTimes_changed = availableDynamicTimes_changed;
        $ctrl.allAvailableDynamicTimes = null;
        $ctrl.ToTime_changed = ToTime_changed;
        $ctrl.timeUnitQty = 1;
        $ctrl.selectedToTime = null;
        $ctrl.showPrices = showPrices;
        $ctrl.scheduleType = 'PRIMARY';
        $ctrl.floatingTimeType = null;
        $ctrl.showFloatingHourlyTime = showFloatingHourlyTime;
        $ctrl.availableDynamicMonthlyDates_changed = availableDynamicMonthlyDates_changed;
        $ctrl.selectedDynamicMonthlyDate = null;
        $ctrl.getAvailableDynamicMonthlyDates = getAvailableDynamicMonthlyDates;

        $ctrl.availableTimeUnitQty = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        $ctrl.timeUnitQty_Changed = timeUnitQty_Changed;


        $ctrl.settingInfo = SettingInfoCustom.getSettingInfoByCurrentCompany().query();
        //test


        loadAll();

        loadPage();

        function loadAll() {


            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('orderBagServiceItemDtail');
            translatePartialLoader.addPart('orderBagServiceItem');
            translatePartialLoader.addPart('orderBagItemOption');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('participantPerson');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();


            $ctrl.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(onSuccess);

            function onSuccess() {

                setDefualtValues();


            }


            getPriceInfoDtail();

        }

        function setDefualtValues() {
            if ($ctrl.initMode == 'fromURL') {
                setDefualtServiceItem();

            }


        }

        function setDefualtServiceItem() {
            if ($ctrl.defaultServiceItemId != null && $ctrl.defaultServiceItemId != undefined) {
                $ctrl.orderBagServiceItem.serviceItemId = Number($ctrl.defaultServiceItemId);
                $ctrl.serviceItem_changed();
                setDefualtTimeSession();
                setDefualtDateAndTime();
                // loadAvailableDates();
            }
        }

        function setDefualtTimeSession() {
            if ($ctrl.defaultServiceTimeSessionId != null && $ctrl.defaultServiceTimeSessionId != undefined) {
                ;
                ServiceTimeSession.get({id: $ctrl.defaultServiceTimeSessionId}).$promise.then(function (serviceTimeSession) {
                    $ctrl.selectedDate = dateUtil.convertToISOString(serviceTimeSession.startDate);
                    //$ctrl.selectedDate = serviceTimeSession.startDate.toISOString().split('T')[0];
                    loadAvailableTimes(function () {
                        $ctrl.orderBagServiceItem.serviceTimeSession = {};
                        $ctrl.orderBagServiceItem.serviceTimeSession.id = Number($ctrl.defaultServiceTimeSessionId);
                        availableTimes_changed();
                    });

                });
            }
        }

        function setDefualtDateAndTime() {
            if ($ctrl.defaultStartDate != null && $ctrl.defaultStartDate != undefined &&
                $ctrl.defaultEndDate != null && $ctrl.defaultEndDate != undefined) {


                $ctrl.selectedDynamicDate = dateUtil.convertToISOString(new Date($ctrl.defaultStartDate));
                getAvailableDynamicDates(function () {
                    $ctrl.getAvailableDynamicTimes(function () {
                        $ctrl.selectedDynamicTime = new Date($ctrl.defaultStartDate).toISOString();
                        $ctrl.availableDynamicTimes_changed();
                        $ctrl.selectedToTime = new Date($ctrl.defaultEndDate).toISOString();
                        $ctrl.ToTime_changed();

                    });


                });


                //loadAvailableTimes(function () {
                //
                //    availableTimes_changed();
                //});
            }
        }

        function getPriceInfoDtail() {

            if ($ctrl.scheduleType != 'FLOAT_TIME_SESSIONS') {
                if ($ctrl.orderBagServiceItem.serviceItemId == undefined || $ctrl.orderBagServiceItem.serviceItemId == null || $ctrl.orderBagServiceItem.serviceTimeSession == undefined || $ctrl.orderBagServiceItem.serviceTimeSession == null || $ctrl.orderBagServiceItem.serviceTimeSession.id == null) {
                    // error
                    // have to evaluate
                    return;
                }
                if ($ctrl.orderBagServiceItem != null && $ctrl.orderBagServiceItem != undefined && $ctrl.orderBagServiceItem.status != null && $ctrl.orderBagServiceItem.status == 1) {
                    //do nothing
                    // in view mode and not editable
                } else {

                    PriceInfoDtailCustom.PriceInfoDtailByServiceTimeSession($ctrl.orderBagServiceItem.serviceItemId, $ctrl.orderBagServiceItem.serviceTimeSession.id).query(function (result) {

                        $ctrl.priceInfoDtails = result;
                        addOrderBagDtails();
                        //reloadPrices();
                    });

                }
            } else {
                if ($ctrl.orderBagServiceItem.serviceItemId == undefined || $ctrl.orderBagServiceItem.serviceItemId == null || $ctrl.orderBagServiceItem.serviceTimeSession == undefined || $ctrl.orderBagServiceItem.serviceTimeSession == null) {
                    // error
                    // have to evaluate
                    return;
                }
                if ($ctrl.orderBagServiceItem != null && $ctrl.orderBagServiceItem != undefined && $ctrl.orderBagServiceItem.status != null && $ctrl.orderBagServiceItem.status == 1) {
                    //do nothing
                    // in view mode and not editable
                } else {

                    PriceInfoDtailCustom.getPriceInfoDtailByServiceItemFromDate($ctrl.orderBagServiceItem.serviceItemId, $ctrl.orderBagServiceItem.serviceTimeSession.startTime).query(function (result) {

                        $ctrl.priceInfoDtails = result;
                        addOrderBagDtails();
                        //reloadPrices();
                    });

                }

            }
        }

        function saveDtail() {
            $ctrl.isSaving = true;
            if ($ctrl.orderBagServiceItem.id !== null && $ctrl.orderBagServiceItem.id != undefined) {
                OrderBagServiceItem.update($ctrl.orderBagServiceItem, onSaveSuccess, onSaveError);
            } else {
                $ctrl.orderBagServiceItem.id = null;
                OrderBagServiceItem.save($ctrl.orderBagServiceItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {


            $ctrl.isSaving = false;
            $ctrl.orderBagServiceItem = result;
            //reloadPrices();
            //findFormState();
            initParticipant();
            //$ctrl.formState ='participant';
        }

        function onSaveError() {
            $ctrl.isSaving = false;
        }

        function reloadPrices() {

            if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined
                || $ctrl.orderBagServiceItem.length == 0 || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == null
                || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined
                || $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length == 0
            ) {
                return;
            }

            angular.forEach($ctrl.orderBagServiceItem.orderBagServiceItemDtail, function (v) {
                angular.forEach($ctrl.priceInfoDtails, function (p) {
                    if (v.priceInfoDtail.id == p.id) {
                        p.gty = v.gty;
                        if (v.options != null && v.options != undefined) {
                            p.options = [];
                            p.options = v.options;
                        }
                    }

                });

            });

        }

        function addOrderBagDtails() {

            clearOrderBagDetails();

            if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined) {
                $ctrl.orderBagServiceItem = {};
            }
            if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined) {
                $ctrl.orderBagServiceItem.orderBagServiceItemDtail = [];
            }

            var x;
            for (var i = 0, len = $ctrl.priceInfoDtails.length; i < len; i++) {

                x = $ctrl.priceInfoDtails[i];
                if (x == null)
                    continue;

                //if priceInfoDetailID set in OrderBagServiceItemDtail must Update Quantity
                //if (UpdateExistOrderBagServiceItemDtail(x, orderbagOptions))
                if (false) {
                    //do nothing
                } else {


                    $ctrl.orderBagServiceItem.orderBagServiceItemDtail.push({
                        gty: 1,
                        price: x.price,
                        discount: x.discount,
                        vat: 0,
                        totalPrice: 0,
                        serviceTimeSession: $ctrl.orderBagServiceItem.serviceTimeSession,
                        //priceInfoDtailId: x.id,
                        priceInfoDtail: x,
                        orderBagItemOptions: null,
                        timeUnitQty: $ctrl.timeUnitQty
                    });
                }
            }

            computeTotalPrice();
        }

        function computeTotalPrice() {
            var orderBag = {};
            orderBag.orderBagServiceItems = [];
            orderBag.orderBagServiceItems.push($ctrl.orderBagServiceItem);
            OrderBagCustom.computeFinalPrice().save(orderBag, function (result) {
                console.log(result);
                if (result.orderBagServiceItems[0])
                    $ctrl.orderBagServiceItem = result.orderBagServiceItems[0];
            })

            //if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined)
            //    return;
            //
            //var row;
            //var price = 0;
            //var discount = 0;
            //var vat = 0;
            //
            //var rowDiscount = 0;
            //var rowVat = 0;
            //var rowTotalPrice = 0;
            //
            //var subtotalService = 0;
            //var subtotalOptions = 0;
            //var subtotalDiscount = 0;
            //var subtotalVat = 0;
            //var finalPrice = 0;
            //var sumQty = 0;
            //
            //
            //if ($ctrl.settingInfo != null && $ctrl.settingInfo.financialSetting != null && $ctrl.settingInfo.financialSetting.taxPercentage != null) {
            //    vat = $ctrl.settingInfo.financialSetting.taxPercentage;
            //}
            //
            //
            //for (var i = 0, len = $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length; i < len; i++) {
            //
            //    row = $ctrl.orderBagServiceItem.orderBagServiceItemDtail[i];
            //    if (row.price != null)
            //        price = row.price;
            //    else
            //        price = 0
            //
            //    if (row.discount != null)
            //        discount = row.discount;
            //    else
            //        discount = 0
            //
            //    if (discount > 0) {
            //        rowDiscount = Math.round((discount * price / 100) * row.gty * $ctrl.timeUnitQty);
            //        row.totalPrice = (price * row.gty * $ctrl.timeUnitQty ) - rowDiscount;
            //    }
            //    else {
            //        rowDiscount = 0;
            //        row.totalPrice = price * row.gty * $ctrl.timeUnitQty;
            //    }
            //
            //    if (vat > 0) {
            //        rowVat = Math.round((row.totalPrice * vat) / 100);
            //        row.totalPrice = row.totalPrice + rowVat;
            //    }
            //
            //    sumQty += row.gty;
            //
            //    subtotalService = subtotalService + price * row.gty * $ctrl.timeUnitQty;
            //    subtotalDiscount = subtotalDiscount + rowDiscount;
            //    subtotalVat = subtotalVat + rowVat;
            //    rowTotalPrice = rowTotalPrice + row.totalPrice;
            //}
            //
            //$ctrl.orderBagServiceItem.subtotalOptionPrice = calculateOptionPrice(sumQty);
            //$ctrl.orderBagServiceItem.subtotalServicePrice = subtotalService;
            //$ctrl.orderBagServiceItem.subtotalVAT = subtotalVat;
            //$ctrl.orderBagServiceItem.subtotalDiscount = subtotalDiscount;
            //$ctrl.orderBagServiceItem.totalRowPrice = subtotalService + $ctrl.orderBagServiceItem.subtotalOptionPrice + subtotalVat - subtotalDiscount;

        }

        function calculateOptionPrice(qty) {

            var sumOfOptionPrice = 0;
            var row;
            if ($ctrl.orderBagServiceItem.options)
                for (var i = 0, len = $ctrl.orderBagServiceItem.options.length; i < len; i++) {

                    row = $ctrl.orderBagServiceItem.options[i];
                    if (row.selected) {
                        sumOfOptionPrice += row.priceInfoDtail.price * qty;
                    }
                }

            return sumOfOptionPrice;
        }


        function UpdateExistOrderBagServiceItemDtail(priceInfoDtail, options) {
            //
            //var hasChanged = false;
            //if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined
            //    || $ctrl.orderBagServiceItem.length == 0 || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == null
            //    || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined
            //    || $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length == 0
            //) {
            //    hasChanged = false;
            //}
            //
            //
            //angular.forEach($ctrl.orderBagServiceItem.orderBagServiceItemDtail, function (v) {
            //    if (v.priceInfoDtail.id == priceInfoDtail.id) {
            //        v.gty = priceInfoDtail.gty;
            //        v.orderBagItemOptions = options;
            //        hasChanged = true;
            //    }
            //
            //});
            //
            //
            //return hasChanged;
        }

        function prev() {
            $ctrl.formState = 'orderbagitem';
            //  reloadPrices();
        }

        function initParticipant() {
            $ctrl.orderBagServiceItem.participantPersons = [];

            for (var i = 0, len = $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length; i < len; i++) {
                for (var j = 0, jlen = $ctrl.orderBagServiceItem.orderBagServiceItemDtail[i].gty; j < jlen; j++) {
                    $ctrl.orderBagServiceItem.participantPersons.push(
                        {
                            personInfoId: null,
                            orderBagItemDtailId: $ctrl.orderBagServiceItem.orderBagServiceItemDtail[i].id,
                            personInfo: null
                        }
                    );
                }
            }

        }

        function FinalApprove() {
            //saveDtail();
        }

        function serviceItem_changed() {

            $ctrl.selectedDate = null;
            $ctrl.selectedServiceTimeSession = {};

            loadServiceItemServants();
            loadAvailableDates();


            getAvailableDynamicDates();
            getAvailableDynamicMonthlyDates();

            loadCurrentScheduleInfo();


        }

        function loadCurrentScheduleInfo() {
            $ctrl.currentScheduleInfo = null;
            if ($ctrl.orderBagServiceItem.serviceItemId == null && $ctrl.orderBagServiceItem.serviceItemId == undefined) {
                return;
            }

            ScheduleInfoCustom.getCurrentScheduleInfoByServiceItem($ctrl.orderBagServiceItem.serviceItemId).query().$promise.then(function (result) {

                $ctrl.currentScheduleInfo = result;
                if ($ctrl.currentScheduleInfo.floatingTimeType != null) {
                    $ctrl.floatingTimeType = $ctrl.currentScheduleInfo.floatingTimeType;
                }
                if ($ctrl.currentScheduleInfo.scheduleType != null) {
                    $ctrl.scheduleType = $ctrl.currentScheduleInfo.scheduleType;
                }

            });

        }

        function openPersonInfoModal() {
            $uibModal.open({
                templateUrl: 'app/entities/participant-person/order-bag-item-participant-person-dialog.html',
                controller: 'OrderBagParticipantPersonDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            }).result.then(function (result) {
                addParticipantPerson(result);
            }, function () {
                //nothing
            });


        }

        function addParticipantPerson(participant) {

            if (participant == null || participant == undefined || participant.personInfo == null)
                return;
            if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined) {
                $ctrl.orderBagServiceItem = {};
            }
            if ($ctrl.orderBagServiceItem.participantPersons == null || $ctrl.orderBagServiceItem.participantPersons == undefined) {
                $ctrl.orderBagServiceItem.participantPersons = [];
            }

            $ctrl.orderBagServiceItem.participantPersons.push(
                {
                    id: null,
                    personInfoId: null,
                    orderBagItemDtailId: null,
                    personInfo: participant.personInfo
                }
            );


        }

        function removeParticipantPerson(person) {


            if (person != null) {
                $ctrl.orderBagServiceItem.participantPersons = $ctrl.orderBagServiceItem.participantPersons.filter(function (v) {
                        return (v.personInfo.fisrtName != person.fisrtName || v.personInfo.lastName != person.lastName)
                    }
                );
            }

        }

        function clearOrderBagDetails() {
            $ctrl.orderBagServiceItem.orderBagServiceItemDtail = null;
            $ctrl.orderBagServiceItem.orderBagServiceItemDtail = [];
        }

        function changeControlsData() {
            computeTotalPrice();

        }

        function qtyChanged() {

            changeControlsData();
        }

        function loadAvailableDates() {


            if ($ctrl.orderBagServiceItem.serviceItemId == undefined || $ctrl.orderBagServiceItem.serviceItemId == null) {
                // error
                // have to evaluate
                return;
            }
            $ctrl.orderBagServiceItem.serviceTimeSession = null;
            $ctrl.availableDates = [];
            var dates = ServiceTimeSessionCustom.getServiceTimeSessionFromNow($ctrl.orderBagServiceItem.serviceItemId).query(function (result) {
                angular.forEach(dates, function (d) {


                    if (d.capacity > 0) {

                        var similarDate = $ctrl.availableDates.filter(function (d2) {
                            if (d2.date == d.startDate)
                                return d2;
                        })
                        if (similarDate.length == 0) {
                            $ctrl.availableDates.push({date: d.startDate});
                        }
                    }

                });

            });


        }

        function servant_changed() {

        }

        function availableDates_changed() {
            loadAvailableTimes();
        }

        function loadAvailableTimes(then) {

            if ($ctrl.selectedDate == undefined || $ctrl.selectedDate == null)
                return;

            $ctrl.orderBagServiceItem.serviceTimeSession = null;

            var dateTime = new Date($ctrl.selectedDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            ServiceTimeSessionCustom.getAvailableServiceTimeSessionsInOneDate($ctrl.orderBagServiceItem.serviceItemId, dateTime.toISOString()).query(function (list) {
                $ctrl.availableTimes = list;
                if (then)
                    then();

            });

        }

        function availableTimes_changed() {
            getPriceInfoDtail();
            changeControlsData();
        }

        function loadServiceItemServants() {
            $ctrl.orderBagServiceItem.servant = null;
            if ($ctrl.orderBagServiceItem.serviceItemId == null || $ctrl.orderBagServiceItem.serviceItemId == undefined)
                return;

            $ctrl.serviceItems.filter(function (v) {
                    if (v.id == $ctrl.orderBagServiceItem.serviceItemId) {
                        $ctrl.servants = v.servants;
                    }
                }
            );
        }

        function getAvailableDynamicDates(then) {
            $ctrl.availableDynamicDates = ScheduleInfoCustom.getDynamicAvailableDatesByServiceId($ctrl.orderBagServiceItem.serviceItemId).query(function (list) {
                if (then)
                    then();


            });
        }

        function getAvailableDynamicTimes(then) {
            $ctrl.selectedDynamicTime = null;
            $ctrl.selectedToTime = null;
            var dateTime = new Date($ctrl.selectedDynamicDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            ScheduleInfoCustom.getDynamicAvailableTimesByServiceIdInOneDate($ctrl.orderBagServiceItem.serviceItemId, dateTime.toISOString()).query().$promise.then(function (result) {

                $ctrl.allAvailableDynamicTimes = result;
                if (then)
                    then();
                $ctrl.availableDynamicTimes = result.filter(function (v) {
                        return (v.capacity > 0)
                    }
                );
            });

        }

        function availableDynamicDates_changed() {

            getAvailableDynamicTimes();
        }

        function availableDynamicTimes_changed() {
            findToTimePeriod();
        }

        function findToTimePeriod() {

            if ($ctrl.selectedDynamicTime == undefined || $ctrl.selectedDynamicTime == null)
                return null;

            $ctrl.selectedToTime = null;

            $ctrl.toTimePeriodList = [];

            var list = $ctrl.allAvailableDynamicTimes.filter(function (v) {
                    return (v.startTime >= $ctrl.selectedDynamicTime)
                }
            );


            var keepGoing = true;
            angular.forEach(list, function (time) {

                if (keepGoing) {
                    if (time.capacity == 0) {
                        keepGoing = false;
                    }
                    if (keepGoing == true)
                        $ctrl.toTimePeriodList.push(time);
                }
            })


        }

        function ToTime_changed() {
            computeTimeUnitQty();
            if ($ctrl.selectedDynamicTime != null && $ctrl.selectedToTime != null)
                $ctrl.orderBagServiceItem.serviceTimeSession = createTimeSession($ctrl.selectedDynamicTime, $ctrl.selectedToTime);

            getPriceInfoDtail();
        }

        function computeTimeUnitQty() {

            var span = {
                startTime: $ctrl.selectedDynamicTime,
                endTime: $ctrl.selectedToTime,
                serviceItemId: $ctrl.orderBagServiceItem.serviceItemId
            }
            TimingInfo.computeTimeUnitQty().save(span, function (result) {
                $ctrl.timeUnitQty = result.timeUnitQty;
            })

            //;
            //if ($ctrl.toTimePeriodList == undefined || $ctrl.toTimePeriodList == null || $ctrl.toTimePeriodList.length == 0) {
            //    $ctrl.timeUnitQty = 1;
            //    return;
            //}
            //if ($ctrl.selectedToTime == undefined || $ctrl.selectedToTime == null) {
            //    $ctrl.timeUnitQty = 0;
            //    return;
            //}
            //
            //
            //var keepGoing = true;
            //var timeUnitCount = 0;
            //var capacity = 100;
            //angular.forEach($ctrl.toTimePeriodList, function (toTime) {
            //    ;
            //    if (keepGoing) {
            //
            //            if(toTime.capacity!=null && toTime.capacity < capacity)
            //                capacity = toTime.capacity;
            //            if (toTime.endTime == $ctrl.selectedToTime) {
            //                keepGoing = false;
            //            }
            //
            //            timeUnitCount++;
            //
            //        }
            //    }
            //);
            //
            //if (timeUnitCount > 0)
            //    $ctrl.timeUnitQty = timeUnitCount;
            //
            //$ctrl.dynamicCapacity = capacity;

        }

        function createTimeSession(fromTime, toTime) {
            var newTimeSession = {};

            var fromDate = new Date(fromTime.toString());
            var toDate = new Date(toTime.toString());


            newTimeSession.startTime = fromTime;
            newTimeSession.endTime = toTime;
            newTimeSession.startDate = fromDate;
            newTimeSession.endDate = toDate;
            newTimeSession.capacity = $ctrl.dynamicCapacity;

            return newTimeSession;


        }

        function showPrices() {

            if ($ctrl.scheduleType != 'FLOAT_TIME_SESSIONS') {
                if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.orderBagServiceItem.serviceTimeSession != undefined && $ctrl.orderBagServiceItem.serviceTimeSession.id != undefined)
                    return true;
            }
            if ($ctrl.scheduleType == 'FLOAT_TIME_SESSIONS') {
                if ($ctrl.floatingTimeType == 'HOURLY') {
                    if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.selectedDynamicTime != null && $ctrl.selectedToTime != null)
                        return true;
                }
                if ($ctrl.floatingTimeType == 'MONTHLY') {
                    if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.selectedDynamicMonthlyDate != null && $ctrl.timeUnitQty != null)
                        return true;
                }
            }
        }

        function showFloatingHourlyTime() {
            if ($ctrl.scheduleType == null || $ctrl.floatingTimeType == null || $ctrl.floatingTimeType == undefined)
                return false;

            if ($ctrl.scheduleType == 'FLOAT_TIME_SESSIONS' && $ctrl.floatingTimeType == 'HOURLY')
                return true;
        }


        function getAvailableDynamicMonthlyDates() {
            ;
            $ctrl.availableDynamicMonthlyDates = [];
            //if($ctrl.scheduleType!='FLOAT_TIME_SESSIONS' || $ctrl.floatingTimeType != 'MONTHLY')
            //{
            //    return null;
            //}

            $ctrl.availableDynamicMonthlyDates = ScheduleInfoCustom.getDynamicAvailableMonthlyDatesByServiceId($ctrl.orderBagServiceItem.serviceItemId).query();


        }

        function availableDynamicMonthlyDates_changed() {
            ;
            if ($ctrl.selectedDynamicMonthlyDate != null && $ctrl.timeUnitQty != null) {
                var newTimeSession = {};

                var fromDate = new Date($ctrl.selectedDynamicMonthlyDate.spanDate.toString());
                var toDate = new Date($ctrl.selectedDynamicMonthlyDate.spanDate.toString());

                toDate.setDate(toDate.getDate() + (30 * $ctrl.timeUnitQty));

                var startTime = new Date($ctrl.selectedDynamicMonthlyDate.startTime.toString());
                var endTime = new Date($ctrl.selectedDynamicMonthlyDate.endTime.toString());
                endTime.setDate(endTime.getDate() + (30 * $ctrl.timeUnitQty));


                newTimeSession.startTime = startTime.toISOString();
                newTimeSession.endTime = endTime.toISOString();
                newTimeSession.startDate = fromDate.toISOString();
                newTimeSession.endDate = toDate.toISOString();
                //newTimeSession.capacity = $ctrl.dynamicCapacity;
                newTimeSession.capacity = 1;

                $ctrl.orderBagServiceItem.serviceTimeSession = newTimeSession;

                getPriceInfoDtail();
            }

        }

        function timeUnitQty_Changed() {
            availableDynamicMonthlyDates_changed();
            computeTotalPrice();
        }


        //$scope.$watch('$ctrl.orderBagServiceItem.options',function(si){
        //    ;
        //    changeControlsData();
        //});

    }


    var OrderBagServiceItem = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/orderbag-service-item/partial-form.orderbag-service-item.html',
        controller: OrderBagServiceItemController,
        bindings: {
            //serviceItemId: '<',
            //selectedServiceTimeSession: '=',
            orderBagServiceItem: '=',
            defaultServiceItemId: '=',
            defaultServiceTimeSessionId: '=',
            defaultStartDate: '=',
            defaultEndDate: '=',
            initMode: '='

            //formState:'=',

        }


    };

    angular
        .module('tikonApp')
        .component('pfOrderBagServiceItem', OrderBagServiceItem)

    OrderBagServiceItemController.$inject = ['$uibModal', '$scope', '$state', 'PriceInfoCustom', 'PriceInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ServiceOptionItem', 'ServiceOptionItemCustom', 'PriceInfoDtailCustom', 'OrderBagServiceItem', 'ServiceItemCustom', 'ServiceTimeSessionCustom', 'SettingInfoCustom', 'ServiceTimeSession', 'DateUtils', 'ScheduleInfoCustom', 'TimingInfo', 'OrderBagCustom'];


})();

